import { LOAD_UIKIT_SUCCESS } from '../actionTypes';

export const loadUIkitSuccess = () => ({
    type: LOAD_UIKIT_SUCCESS,
    payload: {},
});
